import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilesService } from 'src/app/service/files.service';
import { AdminService } from 'src/app/service/admin.service';
import { EventsService } from 'src/app/service/events.service';
import { NotificationService } from 'src/app/service/notification.service';
import { NavbarService } from 'src/app/service/navbar.service';
import { SelectOption } from 'src/app/model/select.option';
import { zip, Observable, Subscription, of, forkJoin } from 'rxjs';
import { Event } from 'src/app/model/event';
import { SubmissionsService } from 'src/app/service/submissions.service';
import { SubmissionStatus } from 'src/app/model/paper';
import { Track } from 'src/app/model/track';
import { EventInfo } from 'src/app/model/eventInfo';
@Component({
  selector: 'app-submission-files',
  templateUrl: './submission-files.component.html',
  styleUrls: ['./submission-files.component.scss']
})
export class SubmissionFilesComponent implements OnInit,  OnDestroy{

  event: Event;
  public form: FormGroup;

  public trackValues: Array<SelectOption> = [];
  public trackFilesValues: Array<SelectOption> = [];

  public statusValues: Array<{name:string, checked: boolean}> = [];

  public events: Array<Event> = [];
  public trackAndTrackFiles: Array<Track> = [];

  public loadingLink = false;

  public track_id : Number;

  public link;
  subscriptions: Subscription[] = [];

  constructor(
    public adminService: AdminService,
    private eventsService: EventsService,
    private submissionService: SubmissionsService,
    private fb: FormBuilder,
    private filesService: FilesService,
    private navbarService: NavbarService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.navbarService.loadingStart();

    if (!this.event) {
      this.adminService.getEvent().subscribe(event => {
        this.event = event;
      },
      () => {},
      () => {
        this.initForm();
      });
    } else {
      this.initForm();
    }
  }

  ngOnDestroy (): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.navbarService.loadingStop();
  }

  initForm(): void {
    this.eventsService.getAllSubEvents(this.event.id).subscribe(subEvents => {
      subEvents = subEvents.sort((a, b) => `${a.acronym}-${a.year}-${a.name}`.localeCompare(`${b.acronym}-${b.year}-${b.name}`));
      this.events = [this.event, ...subEvents];
    });

    this.trackAndTrackFiles = this.event.tracks;

    this.eventsService.getAllSubEventsTracks(this.event?.id).subscribe(tracks => {
      this.trackAndTrackFiles = [...this.trackAndTrackFiles, ...tracks];
    });

    this.statusValues = SubmissionStatus.toIterable().map(value => ({
      name: SubmissionStatus[value],
      checked: value == SubmissionStatus.ACCEPTED ? true : false 
    }));
    
    this.navbarService.loadingStop();
  }

  public tracksByEvent(eventId: number): Array<Track> {
    return this.trackAndTrackFiles?.filter(t => t.event == eventId);
  }

  public onChangeTrackFiles(value: boolean, trackId: number): void {
    this.trackAndTrackFiles.find(t => t.id == trackId).trackFiles.map(file => {
      file.downloadSelected = value;
      this.onChangeTrackFileSelected(value, file.id);
    });
  }

  public onChangeAllTrackFiles(value: boolean): void {
    this.trackAndTrackFiles.forEach(t => t.trackFiles.map(file => {
      file.downloadSelected = value;
      this.onChangeTrackFileSelected(value, file.id);
    }));
  }

  public onChangeTrackFileSelected(value: boolean, trackFileId: number): void {
    this.eventsService.updateTrackFile({'downloadSelected': value}, trackFileId).subscribe(trackFile => {
    });
  }

  public onChangeAllStatus(value: boolean): void {
    this.statusValues.map(status => status.checked = value);
  }

  public markAll(value: boolean): void {
    this.onChangeAllTrackFiles(value);
    this.onChangeAllStatus(value);
  }

  public trackFilesLength(trackId: number): number {
   return this.trackAndTrackFiles.find(t => t.id == trackId).trackFiles.length;
  }

  isStatus(status: string, trackId: number): boolean {
    const trackFilesLength =  this.trackFilesLength(trackId);
    const selectedTrackFilesLength = this.trackAndTrackFiles.find(t => t.id == trackId).trackFiles.filter(files => files.downloadSelected).length;
    
    return status == 'checked' ? trackFilesLength != 0 && trackFilesLength == selectedTrackFilesLength : trackFilesLength > 0 && selectedTrackFilesLength > 0 && trackFilesLength != selectedTrackFilesLength;
  }

  get selectedTrackFiles(): number {    
    return this.selectedTrackFilesIds().length;
  }

  public selectedTrackFilesIds(): Array<number> {
    let selectedIds = this.trackAndTrackFiles.flatMap(t => t.trackFiles.filter(tf => tf.downloadSelected).map(file => file.id));
    return selectedIds;
  }

  getLink() {
    const trackFilesSelected = this.selectedTrackFilesIds();
    const statusSelected = this.statusValues.filter(s => s.checked).map(st => st.name);
    this.navbarService.loadingStart();
    this.loadingLink = true;
    this.subscriptions.push(this.eventsService.getSubmissionFilesByTrackFiles(this.event.id,trackFilesSelected,statusSelected).subscribe(
      response => {
        this.link = response.link;
        this.loadingLink = false;
      }, error => {
        this.notificationService.notifyError('errors.error-create-link');
        this.loadingLink = false;
      }, () => {
        let downloadURL = this.link
        let contentType = 'application/zip';
        let name = this.event.acronym + '-' + this.event.year + '_Files'
        this.subscriptions.push(this.filesService.downloadTrackFiles(this.link).subscribe((data) => {
          let blob = new Blob([data], {type: contentType});
          downloadURL = URL.createObjectURL(blob);
        }, () => {},
        () => {
          this.navbarService.loadingStop();
          this.downloadLink(downloadURL, name);
        }));
      }));
  }

  downloadLink(downloadURL: string, name: string) {
    // Create link to lownload
    var link = document.createElement('a');
    link.href = downloadURL;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.download = name;
    link.click();
  }
}
